import { handleActions } from 'redux-actions';
import update from 'immutability-helper';
import ReduxStatus from '../../constants/ReduxStatus';
import ActionCreator from './ActionCreator';

const {
  sendQuestionFlowReset,
  sendQuestionFlowRequest,
  sendQuestionFlowSuccess,
  sendQuestionFlowFailure,
} = ActionCreator;

const initialState = {
  reduxStatus: ReduxStatus.STATUS_INITIAL,
  error: null,
};

export default handleActions({
  [sendQuestionFlowReset]: state => update(state, {
    reduxStatus: { $set: ReduxStatus.STATUS_INITIAL },
    error: { $set: null },
  }),
  [sendQuestionFlowRequest]: state => update(state, {
    reduxStatus: { $set: ReduxStatus.STATUS_LOADING },
    error: { $set: null },
  }),
  [sendQuestionFlowSuccess]: state => update(state, {
    reduxStatus: { $set: ReduxStatus.STATUS_NORMAL },
    error: { $set: null },
  }),
  [sendQuestionFlowFailure]: (state, { payload }) => update(state, {
    reduxStatus: { $set: ReduxStatus.STATUS_ERROR },
    error: { $set: payload },
  }),

}, initialState);
